import { isNil, omitBy } from 'lodash';
import { Component as ReactComponent } from 'react';
import { ReactReduxContext } from 'react-redux';

import { ANIMATION_DURATION } from '@optimus-web/common';
import { FadeIn, TransitionViewWrapper, View } from '@optimus-web/core';

import { ErrorHandler, Loader } from '../components/common';
import { bindActions } from './bindActions';

export function viewWrapper(
    Component: $TSFixMe,
    {
        loader,
        Wrapper = TransitionViewWrapper,
        ContentContainer = View,
        error: { onDismiss, onTryAgain, ...errorProps } = {},
    }: $TSFixMe = {}
) {
    return class ViewWrapper extends ReactComponent {
        static contextType = ReactReduxContext;

        errorActions: $TSFixMe;

        constructor(props: $TSFixMe, context: $TSFixMe) {
            super(props, context);
            const actions = omitBy({ onDismiss, onTryAgain }, isNil);
            this.errorActions = bindActions(actions, context.store.dispatch);
        }

        render() {
            let content;
            // @ts-expect-error $TSFixMeError: Property 'keepView' does not exist on type 'Readonly<{}> & Readonly<{ children?: ReactNode; }>'.
            const { keepView } = this.props;

            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            if ((this.props as $TSFixMe).hasFailed) {
                content = <ErrorHandler {...this.errorActions} {...errorProps} {...(this.props as $TSFixMe).error} />;
                // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
            } else if ((this.props as $TSFixMe).isFetching) {
                content = <Loader {...loader} {...(this.props as $TSFixMe).loader} fill />;
            }

            const shouldRenderComponent = !content || keepView;
            const shouldHideComponent = !!content;

            return (
                <Wrapper timeoutExit={ANIMATION_DURATION.fast}>
                    <FadeIn>
                        <ContentContainer aria-live="assertive">{content}</ContentContainer>
                        {
                            // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions
                            shouldRenderComponent && (
                                <ContentContainer
                                    key="component"
                                    hide={shouldHideComponent || undefined}
                                    aria-busy={shouldHideComponent}
                                >
                                    <Component {...this.props} />
                                </ContentContainer>
                            )
                        }
                    </FadeIn>
                </Wrapper>
            );
        }
    };
}

export const fpViewWrapper = (options: $TSFixMe) => (Component: $TSFixMe) => viewWrapper(Component, options);
